import React from "react";
import IconLink from "./IconLink";
import { BasketIcon as BasketIconComponent } from "./icons";

export interface BasketIconProps {
  className?: string;
  "data-testid"?: string;
  onBasketClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  notification?: string;
}

const BasketIcon: React.FC<BasketIconProps> = ({
  className,
  "data-testid": dataTestId,
  onBasketClick,
  notification,
}) => {
  return (
    <IconLink
      href="/basket.page"
      icon={<BasketIconComponent />}
      label="Basket"
      onClick={onBasketClick}
      data-testid={dataTestId || "header-basket-icon"}
      ariaLabel="Basket"
      className={`${className || ""} basket`}
      notification={notification}
    />
  );
};

export default BasketIcon;
